import React, { FunctionComponent } from 'react'
import { useLanguage } from '@/context/LanguageContext'
import { GetSearchRes } from '@/services/cms-api/search/types'
import { useRouter } from 'next/navigation'

interface Prop {
  results: GetSearchRes
  handleClose: () => void
}
const SearchResults: FunctionComponent<Prop> = ({ results, handleClose }) => {
  const { locale } = useLanguage()
  const router = useRouter()

  return (
    <div className='p-4 rounded-lg bg-secondaryMain absolute top-24 left-36 flex gap-8 text-textInverse'>
      <ul className='flex flex-col gap-4' onClick={handleClose}>
        {results.map((item, i) => (
          <li key={i} className='flex gap-2 items-center pl-2 pr-3 py-1 hover:bg-[#525252] rounded-lg cursor-pointer' onClick={() => router.push(item.link)}>
            <span className='text-sm font-bold text-textAdditional'>{locale === 'en' ? item.titleEn : item.titleMn}</span>
            - <span className='text-sm text-textLow '>{locale === 'en' ? item.categoryEn : item.categoryMn}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
export default SearchResults
